module.exports = __webpack_public_path__ + "img/default-head.893c1cd5.svg";